import { createAction, props } from '@ngrx/store';

/**
 * Action to set the active tenant for the application.
 * Triggers tenant-specific styling, icons, and configurations.
 */
export const setTenant = createAction('[Branding] Set Tenant', props<{ tenantName: string }>());
